import {FilterShop} from "./FilterShop";
import {MOBILES} from "../constants";

const months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];
let isFirst = true;

/**
 *  Класс с вызовом общих методов, которые нужны на каждой странице
 * @extends FilterShop
 */
export class CalendarShop extends FilterShop {
    constructor() {
        super();
        this.$filterDate = $(".js-filter-date");
        this.$filterClear = $("#js-filter-clear");
        this.$items = $("#js-event-items");
        this.$message = $("#js-events-message");
        this.$filterDateInput = $(".js-datepicker-filter");
        this.dateRange = null;
        this.$clear = $(".drp-buttons .cancelBtn");
        this.activeDay = null;
        this.activeMonthAndYear = null;
        this.initialDay = null;
    }

    init() {
        this.setCalendar();
        this.applyCalendar();
        this.setUpListeners();
    }

    setCalendar() {
        this.$filterDateInput.daterangepicker(
            {
                autoUpdateInput: false,
                locale: {
                    format: "DD-MM-YYYY",
                    separator: " - ",
                    applyLabel: this.getWord("main", "Apply"),
                    cancelLabel: this.getWord("main", "Clear"),
                    fromLabel: this.getWord("main", "From"),
                    toLabel: this.getWord("main", "To"),
                    daysOfWeek: [
                        this.getWord("date", "Su"),
                        this.getWord("date", "Mo"),
                        this.getWord("date", "Tu"),
                        this.getWord("date", "We"),
                        this.getWord("date", "Th"),
                        this.getWord("date", "Fr"),
                        this.getWord("date", "Sa")
                    ],
                    monthNames: [
                        this.getWord("date", "January"),
                        this.getWord("date", "February"),
                        this.getWord("date", "March"),
                        this.getWord("date", "April"),
                        this.getWord("date", "May"),
                        this.getWord("date", "June"),
                        this.getWord("date", "July"),
                        this.getWord("date", "August"),
                        this.getWord("date", "September"),
                        this.getWord("date", "October"),
                        this.getWord("date", "November"),
                        this.getWord("date", "December")
                    ],
                    firstDay: 1
                }
            },
            this.cb.bind(this)
        );
    }

    /**
     * Метод добавляющий обработчик для кнопок с выбором периода
     * Например для кнопок: На этой неделе, На выходных...
     * @value this.$dateRangeInputs - Кнопки выбора периода {@link FilterShop#$dateRangeInputs}
     * @return Обновляет календарь в соответствии с выбранным периодом {@link CalendarShop#setCustomDateByRange}
     */
    setDateRangeInputs() {
        this.$dateRangeInputs.on("change", e => {
            const input = $(e.currentTarget);
            if (input.prop("checked")) {
                //Выделяем выбранный элемент
                this.$dateRangeInputs.removeClass("active");
                input.addClass("active");

                return this.setCustomDateByRange(input.data("date-from"), input.data("date-to"));
            }
        });
    }

    /**
     * Метод обновляет календарь в соответствии с выбранным периодом
     * @param from - Дата начала (день-месяц-год)
     * @param to - Дата окончания (день-месяц-год)
     * @return Обновляет календарь вешая тригер {@link CalendarShop#applyCalendar}
     */
    setCustomDateByRange(from, to) {
        this.$filterDateInput.data('daterangepicker').setStartDate(from);
        this.$filterDateInput.data('daterangepicker').setEndDate(to);

        return this.$filterDateInput.trigger('apply.daterangepicker', this.$filterDateInput.data('daterangepicker'));
    }

    cb(start, end) {
        const formatStart = this.getDate(start);
        const formatEnd = this.getDate(end);
        if (formatStart === formatEnd) {
            this.$filterDateInput.val(start.format("DD-MM-YYYY"));
            this.$filterDateInput.addClass("alone").removeClass("double");
            this.$filterDate.addClass("alone").removeClass("double");
        } else {
            this.$filterDate.removeClass("alone").addClass("double");
            this.$filterDateInput.removeClass("alone").addClass("double");
            this.$filterDateInput.val(start.format("DD-MM-YYYY") + " — " + end.format("DD-MM-YYYY"));
        }
    }

    resetCalendar() {
        this.dateRange = "";
        this.$filterDateInput.val(this.getWord("main", "Date"));
        const today = new Date().getDate();
        let month = new Date().getMonth();
        month = months[month];
        $.each($(".daterangepicker .calendar-table td.available"), (index, item) => {
            if (Number($(item).text()) === today) {
                this.initialDay = today;
                const monthsAndYears = $(item).parents(".calendar-table").find("th.month");
                $.each(monthsAndYears, (i, el) => {
                    const activeMonth = $(el).text().split(" ")[0];
                    if (activeMonth === month) {
                        this.initialMonthAndYear = $(el).text();
                    }
                });
            }
        });
        this.$filterDate.removeClass("alone double opened visible");
        this.page = 0;
        this.setFilterValues();
        this.getRequest();
    }

    applyCalendar() {
        this.$filterDateInput.on("apply.daterangepicker", (ev, picker) => {
            this.$filterClear.addClass("active");
            const formatStart = picker.startDate.format("DD-MM-YYYY");
            const formatEnd = picker.endDate.format("DD-MM-YYYY");

            if (formatStart === formatEnd) {
                if(isFirst){
                    this.$filterDateInput.addClass("alone").removeClass("double");
                    this.$filterDate.addClass("alone").removeClass("double");
                    this.dateRange = formatStart;
				}

            } else {
                if (isFirst) {
                    $(".applyBtn").addClass("hadDisabled");
                    this.$filterDateInput.addClass("double").removeClass("alone");
                    this.$filterDate.addClass("double").removeClass("alone");
                    this.dateRange = formatStart + " — " + formatEnd;
                    this.$filterDateInput.val(this.dateRange);
                    this.setFilterValues(this.dateRange);
                    this.getRequest();
                    isFirst = false;
                }

            }
            this.$filterDate.removeClass("visible")
        });
    }

    setUpListeners() {
        this.$filterDateInput.on("showCalendar.daterangepicker", () => {
            if (!this.isDesktop.matches) {
                const next = $(".drp-calendar.right .next");
                const month = $(".drp-calendar.left").find(".month");
                month.next().remove();
                month.after(next);
            }
            this.$clear = $(".drp-buttons .cancelBtn");
            if (this.initialDay) {
                $.each($(".daterangepicker .calendar-table th.month"), (index, el) => {
                    if ($(el).text() === this.initialMonthAndYear) {
                        $(el).parents(".calendar-table").addClass("active");
                    }
                });

                $.each($(".daterangepicker .calendar-table td.available"), (index, item) => {
                    $(item).removeClass("active start-date end-date in-range");
                });

                $.each($(".daterangepicker .calendar-table.active td.available"), (index, item) => {
                    if (Number($(item).text()) === this.initialDay) {
                        $(item).addClass("active start-date end-date");
                    }
                });
                this.initialDay = null;
            }


            this.$clear.on("click", () => {
                this.resetCalendar()
            });
        });

        this.mobileInputs.on("click", e => {
            const input = $(e.currentTarget);
            input.parents(".dates__label").addClass("active");
        });

        this.mobileInputs.on("change", e => {
            const input = $(e.currentTarget);
            input.parents(".dates__label").removeClass("active");
            this.page = 0;
            this.setFilterValues();
            this.getRequest();
            if (!this.mobileInputSecond.val()) {
                this.mobileInputSecond.val(this.mobileInputFirst.val())
            }
            this.$filterClear.addClass("active");
        });

        this.$filterDateInput.on("hide.daterangepicker", () => {
            function removeOpened() {
                this.$filterDate.removeClass("opened");
            }

            this.$clear.off("click");
            setTimeout(removeOpened.bind(this), 100);
        });

        this.$filterDateInput.on("apply.daterangepicker", () => {
            if (!$(".applyBtn").hasClass("hadDisabled")) {
                this.page = 0;
                this.setFilterValues();
                this.getRequest();
            }
        });

        this.$filterDateInput.on("click", () => {
            const dateRangePicker = $(".daterangepicker");
            const that = this;

            if (that.$filterDate.hasClass('opened')) {
                dateRangePicker.hide();
                that.$filterDate.removeClass("opened");
            } else {
                dateRangePicker.show();
                that.$filterDate.addClass("opened");
                if ($(".applyBtn").hasClass("hadDisabled")) {
                    const monthsAndYears = $(".daterangepicker").find("table th.month");
                    $.each(monthsAndYears, (index, el) => {
                        if ($(el).text() === this.activeMonthAndYear.text()) {
                            const days = $(el).parents("table").find("td.available");
                            $.each(days, (i, item) => {
                                $(item).removeClass("active start-date end-date");
                                if ($(item).text() === this.activeDay.text()) {
                                    $(item).addClass("active start-date end-date")
                                }
                            })
                        }
                    })
                }
            }
        });

        this.$filterDateInput.on("focus", () => {
            this.$filterDateInput.addClass("input")
        });

        this.$filterDateInput.on("blur", () => {
            if (!this.$filterDateInput.val()) {
                this.$filterDateInput.val(this.getWord("main", "Date"));
            }
        });

        $("body").on("scroll", () => {
            const cords = this.$filterDate[0].getBoundingClientRect();
            const top = cords.y + this.$filterDate.height();
            $(".daterangepicker").css("top", top);
        });

        $(document).on("mouseup", e => {
            if ($(e.target).hasClass("available")) {
                if ($(".drp-buttons .applyBtn").attr("disabled")) {
                    $(".drp-buttons .applyBtn").removeAttr("disabled").addClass("hadDisabled");
                }
            }
            if ($(".daterangepicker td.active").length > 1) {
                $(".drp-buttons .applyBtn").removeClass("hadDisabled");
            }
        });

        const getDate = el => {
            let activeDay = el.text() < 10 ? "0" + el.text() : el.text();
            this.activeMonthAndYear = el.parents("table").find("th.month");
            let activeMonth = this.activeMonthAndYear.text().split(" ")[0];
            let activeYear = this.activeMonthAndYear.text().split(" ")[1];
            let activeNumberMonth = months.indexOf(activeMonth) + 1;
            activeNumberMonth = activeNumberMonth < 10 ? "0" + activeNumberMonth : activeNumberMonth;
            return `${activeDay}-${activeNumberMonth}-${activeYear}`;
        };

        $(document).on("mouseup", ".applyBtn", () => {
            if ($(".applyBtn").hasClass("hadDisabled")) {
                this.activeDay = $(".daterangepicker td.active");
                this.dateRange = getDate(this.activeDay);
                this.page = 0;
            }
            if ($(".daterangepicker td.active").length === 2) {
                $(".drp-buttons .applyBtn").removeClass("hadDisabled");
                let dateRange = "";
                $.each($(".daterangepicker td.active"), (index, el) => {
                    dateRange += getDate($(el));
                    if (index === 0) {
                        dateRange += " — ";
                    }
                });

                this.$filterDate.addClass("double").removeClass("alone");
                this.$filterDateInput.addClass("double").removeClass("alone");
                this.dateRange = dateRange;
                this.$filterDateInput.val(dateRange);
            }
            if ($(".daterangepicker td.active").length === 1) {
                this.$filterDate.removeClass("double").addClass("alone");
                this.$filterDateInput.removeClass("double").addClass("alone");
                this.activeDay = $(".daterangepicker td.active");
                this.dateRange = getDate(this.activeDay);
                this.$filterDateInput.val(this.dateRange);
				this.setFilterValues(this.dateRange);
                this.getRequest();
            }
        })
    }
}
